// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InvitesPending {
  width: 465px;
  /* height: 54px; */
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  background-color: #efeeed;
  border-radius: 50px;
  box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),
    -6px -6px 12px rgba(255, 255, 255, 0.5);
  cursor: pointer;
}

@media (max-width: 768px) {
  .InvitesPending {
    width: 380px;
  }
  .InvitesPending .number {
    margin: 10px 0px 0px 100px;
  }
}
@media (max-width: 320px) {
  .InvitesPending {
    width: 320px;
  }
  .InvitesPending .number {
    margin: 10px 0px 0px 70px;
  }
}
.invite-received-postcard-main-container{
  height: 100%;
  overflow-y: auto;
  scrollbar-width: thin;
  margin-bottom: 10px;
}
.invite-received-postcard {
  display: flex;
  flex-direction: column;
  /* justify-content: center;
      align-items: center; */
  margin: 10px;
  padding: 14px 14px;
  overflow-x: auto;
  border-width: 0px;
  border-radius: 20px;
  /* box-shadow: 0px 2px 8px rgb(139, 146, 149); */
  background-color: #e2ebee;
  opacity: 0.9;
  width: 100%;
}

@media screen and (min-width: 768px) {
  .invite-received-postcard{
    width: 340px;
  }
}

@media screen and (min-width: 1024px) {
  .invite-received-postcard{
    width: 420px;
  }
}
.MuiAccordionSummary-expandIconWrapper {
  flex-basis: 9% !important;
}
.MuiSvgIcon-root {
  color: #a9a9a8 !important;
}
.invite-received-email-text{
  font-family: sans-serif;
  font-weight: 500;
  font-size: 13px;
  color: #707070;
}
.invite-received-invite-text{
  font-family: sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #373334;
}
.invite-received-time-text{
  font-family: sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: #373334;
}
.invite-received-subject-text{
  font-family: sans-serif;
  font-weight: 500;
  font-size: 13px;
  color: #707070;
}
.join-link{
  font-family: sans-serif;
  font-weight: 500;
  font-size: 15px;
  outline: none;
  color: #000000;
}
.match-color-card{
  background-color: #F3F2F0;
}
.no-data-container{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-top: 40px;
}

.no-data-container p {
  font-size: 16px !important;
}`, "",{"version":3,"sources":["webpack://./src/Modules/Activity/Activites/Invites Pending/InvitesPending.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB;2CACyC;EACzC,eAAe;AACjB;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB;4BAC0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gDAAgD;EAChD,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".InvitesPending {\r\n  width: 465px;\r\n  /* height: 54px; */\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-top: 30px;\r\n  background-color: #efeeed;\r\n  border-radius: 50px;\r\n  box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),\r\n    -6px -6px 12px rgba(255, 255, 255, 0.5);\r\n  cursor: pointer;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .InvitesPending {\r\n    width: 380px;\r\n  }\r\n  .InvitesPending .number {\r\n    margin: 10px 0px 0px 100px;\r\n  }\r\n}\r\n@media (max-width: 320px) {\r\n  .InvitesPending {\r\n    width: 320px;\r\n  }\r\n  .InvitesPending .number {\r\n    margin: 10px 0px 0px 70px;\r\n  }\r\n}\r\n.invite-received-postcard-main-container{\r\n  height: 100%;\r\n  overflow-y: auto;\r\n  scrollbar-width: thin;\r\n  margin-bottom: 10px;\r\n}\r\n.invite-received-postcard {\r\n  display: flex;\r\n  flex-direction: column;\r\n  /* justify-content: center;\r\n      align-items: center; */\r\n  margin: 10px;\r\n  padding: 14px 14px;\r\n  overflow-x: auto;\r\n  border-width: 0px;\r\n  border-radius: 20px;\r\n  /* box-shadow: 0px 2px 8px rgb(139, 146, 149); */\r\n  background-color: #e2ebee;\r\n  opacity: 0.9;\r\n  width: 100%;\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n  .invite-received-postcard{\r\n    width: 340px;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 1024px) {\r\n  .invite-received-postcard{\r\n    width: 420px;\r\n  }\r\n}\r\n.MuiAccordionSummary-expandIconWrapper {\r\n  flex-basis: 9% !important;\r\n}\r\n.MuiSvgIcon-root {\r\n  color: #a9a9a8 !important;\r\n}\r\n.invite-received-email-text{\r\n  font-family: sans-serif;\r\n  font-weight: 500;\r\n  font-size: 13px;\r\n  color: #707070;\r\n}\r\n.invite-received-invite-text{\r\n  font-family: sans-serif;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  color: #373334;\r\n}\r\n.invite-received-time-text{\r\n  font-family: sans-serif;\r\n  font-weight: 500;\r\n  font-size: 12px;\r\n  color: #373334;\r\n}\r\n.invite-received-subject-text{\r\n  font-family: sans-serif;\r\n  font-weight: 500;\r\n  font-size: 13px;\r\n  color: #707070;\r\n}\r\n.join-link{\r\n  font-family: sans-serif;\r\n  font-weight: 500;\r\n  font-size: 15px;\r\n  outline: none;\r\n  color: #000000;\r\n}\r\n.match-color-card{\r\n  background-color: #F3F2F0;\r\n}\r\n.no-data-container{\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  margin-top: 40px;\r\n}\r\n\r\n.no-data-container p {\r\n  font-size: 16px !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
